__webpack_require__.p = "https://www.chatomni.app/chat/";